import { ArrowRightIcon, Typography } from "@cpj-ai/panel-npm-package";
import { Button, Card } from "@heroui/react";
import React, { ReactNode } from "react";

interface PageWrapperProps {
  title: string;
  wrapInCard?: boolean;
  onBack?: () => void;
  showBackButton?: boolean;
  className?: string;
  children: ReactNode;
}

export const PageWrapper: React.FC<PageWrapperProps> = ({
  title,
  wrapInCard = true,
  onBack,
  showBackButton = false,
  className,
  children,
}) => {
  const Container = wrapInCard ? Card : "div";
  const cardClassName = wrapInCard ? "h-full shadow-md p-4 mt-4 border-1 flex-1 overflow-y-auto" : "mt-4";

  return (
    <div className="h-full flex flex-col">
      <div className="flex gap-2 items-center ">
        {showBackButton && (
          <Button
            isIconOnly
            variant="light"
            className="pr-1 pb-2 min-w-0 w-fit h-fit"
            onPress={() => {
              if (onBack) onBack?.();
              else window.history.back();
            }}
          >
            <ArrowRightIcon stroke="#000" className="rotate-180 w-8 h-8 " />
          </Button>
        )}
        <Typography variant="h5">{title}</Typography>
      </div>
      <Container className={`${cardClassName} ${className}`}>{children}</Container>
    </div>
  );
};
